module.exports = __webpack_public_path__ + "img/啤酒.69479f8d.gif";